const textFieldModalCloneEquipModel = {
  name: 'Name New Equipment Type',
  description: 'Equipment description'
};

export default textFieldModalCloneEquipModel;
